import React from "react";
import Select from 'react-select';

class SelectInterests extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <Select
                {...this.props}
                value={this.props.input.value}
                options={this.props.options}
                onChange={(value) => {this.props.input.onChange(value);}}
                multi={true}
                clearable={false}
                onBlur={() => this.props.input.onBlur(this.props.input.value)}
            />
        );
    }
}

export default SelectInterests;



// WEBPACK FOOTER //
// ./web/src/components/interests/SelectInterests.jsx